// extracted by mini-css-extract-plugin
export default {"fileContainer":"file_fileContainer__hGrnd"};